export const Reservations = {
  en: {
    Reservations: 'Reservations',
    Time: 'Time',
    Specialist: 'Specialist',
    Service: 'Service',
    Client: 'Client',
    Phone: 'Phone',
    Guest: 'Guest',
    Location: 'Location',
    Kind: 'Kind',
    'Group class': 'Group class',
    Event: 'Event',
    Wave: 'Wave',
    Status: 'Status',
    Payment: 'Payment',
    Coverage: 'Payment source',
    Channel: 'Booked by',
    New: 'New',
    'Not assigned': 'Purchase not spent',
    'No bookings': 'No bookings',

    status_pending_payment: 'Awaiting payment',
    status_reserved: 'Reserved',
    status_attended: 'Attended',
    status_missed: 'No-show',
    status_cancelled: 'Cancelled',
    status_expired: 'Expired',

    payment_paid: 'Paid',
    payment_pending: 'Awaiting payment',
    payment_none: 'Not applicable',

    coverage_card: 'Card',
    coverage_discount_card: 'Discount card',
    coverage_owned: 'Purchased service',
    coverage_booking_purchase: 'Purchase for this booking',
    coverage_none: 'Not specified',
    'Without a charge': 'Without a charge',

    channel_admin: 'By administrator',
    channel_online_web: 'By client online',
    channel_online_mobile: 'By client in the app',

    kind_personal: 'Personal',
    kind_group: 'Group',
    kind_event: 'Event',

    'Booking details': 'Booking details',
    Note: 'Note',
    'Trainer comment': 'Trainer comment',
    'Custom fields': 'Custom fields',
    Attach: 'Assign',
    'Mark no-show': 'Mark no-show',
    'No-show comment': 'No-show comment',
    'Edit no-show comment': 'Edit no-show comment',
    'Why did the client not come? The comment is optional.':
      'Why did the client not come? The comment is optional.',
    'For example: the client was sick': 'For example: the client was sick',
    'Go to client card': 'Go to client card',
    Reschedule: 'Reschedule',
    'Cancel booking': 'Cancel booking',

    'Who attended': 'Who attended',
    'What pays for it': 'What pays for it',
    'Use immediately': 'Use immediately',
    Cards: 'Cards',
    'Purchased services': 'Purchased services',
    'Nothing to pay with': 'Nothing to pay with',
    'Visits left': 'Visits left',
    'Valid till': 'Valid till',
    Confirm: 'Confirm',

    'Refund reason': 'Refund reason',
    'Cancel this booking?': 'Are you sure you want to cancel the booking?',
    'The trainer’s time is freed. A purchase made for this booking is refunded.':
      'The trainer’s time is freed. A purchase made for this booking is refunded.',
    'The trainer’s time is freed.': 'The trainer’s time is freed.',
    'The place is freed.': 'The place is freed.',
    'Cancellation reason': 'Cancellation reason',
    'Enter the cancellation reason': 'Enter the cancellation reason',
    'The cancellation reason is too long':
      'The cancellation reason is too long',
    'Cancel this registration?': 'Cancel this registration?',
    'The place is freed. A purchase made for this registration is refunded.':
      'The place is freed. A purchase made for this registration is refunded.',
    'Refund method': 'Refund method',
    "Credit to the client's deposit": "Credit to the client's deposit",
    'Pay out from cash register': 'Pay out from cash register',
    'Cash register': 'Cash register',
    'A place hold is marked attended without naming anyone':
      'A place hold is marked attended without naming anyone',
    'Edit booking': 'Edit booking',
    'No free slots for this date': 'No free slots for this date',
    'Pick a slot': 'Pick a slot',
    Save: 'Save',
    'Guest name / phone': 'Guest name / phone',
    'Free start times': 'Free start times',
  },
  uk: {
    Reservations: 'Записи',
    Time: 'Час',
    Specialist: 'Спеціаліст',
    Service: 'Послуга',
    Client: 'Клієнт',
    Phone: 'Телефон',
    Guest: 'Гість',
    Location: 'Локація',
    Kind: 'Тип',
    'Group class': 'Групове заняття',
    Event: 'Подія',
    Wave: 'Хвиля',
    Status: 'Статус',
    Payment: 'Оплата',
    Coverage: 'Джерело оплати',
    Channel: 'Ким заброньовано',
    New: 'Новий',
    'Not assigned': 'Покупку не списано',
    'No bookings': 'Записів немає',

    status_pending_payment: 'Очікує оплати',
    status_reserved: 'Заброньовано',
    status_attended: 'Відвідано',
    status_missed: 'Не прийшов',
    status_cancelled: 'Скасовано',
    status_expired: 'Протерміновано',

    payment_paid: 'Оплачено',
    payment_pending: 'Очікує оплати',
    payment_none: 'Не застосовується',

    coverage_card: 'Картка',
    coverage_discount_card: 'Знижкова картка',
    coverage_owned: 'Придбана послуга',
    coverage_booking_purchase: 'Покупка для цього запису',
    coverage_none: 'Не вказано',
    'Without a charge': 'Без списання',

    channel_admin: 'Адміністратором',
    channel_online_web: 'Клієнтом онлайн',
    channel_online_mobile: 'Клієнтом у застосунку',

    kind_personal: 'Персональне',
    kind_group: 'Групове',
    kind_event: 'Подія',

    'Booking details': 'Деталі запису',
    Note: 'Нотатка',
    'Trainer comment': 'Коментар для тренера',
    'Custom fields': 'Додаткові поля',
    Attach: 'Привʼязати',
    'Mark no-show': 'Позначити неявку',
    'No-show comment': 'Коментар до неявки',
    'Edit no-show comment': 'Змінити коментар до неявки',
    'Why did the client not come? The comment is optional.':
      'Чому клієнт не прийшов? Коментар необовʼязковий.',
    'For example: the client was sick': 'Наприклад: клієнт захворів',
    'Go to client card': 'Перейти до картки клієнта',
    Reschedule: 'Перенести',
    'Cancel booking': 'Скасувати запис',

    'Who attended': 'Хто прийшов',
    'What pays for it': 'Чим оплачується',
    'Use immediately': 'Списати одразу',
    Cards: 'Картки',
    'Purchased services': 'Придбані послуги',
    'Nothing to pay with': 'Немає чим оплатити',
    'Visits left': 'Залишилось відвідувань',
    'Valid till': 'Діє до',
    Confirm: 'Підтвердити',

    'Refund reason': 'Причина повернення',
    'Cancel this booking?': 'Ви впевнені, що хочете скасувати запис?',
    'The trainer’s time is freed. A purchase made for this booking is refunded.':
      'Час тренера звільняється. Покупку, зроблену для цього запису, буде повернуто.',
    'The trainer’s time is freed.': 'Час тренера звільняється.',
    'The place is freed.': 'Місце звільняється.',
    'Cancellation reason': 'Причина скасування',
    'Enter the cancellation reason': 'Вкажіть причину скасування',
    'The cancellation reason is too long': 'Причина скасування задовга',
    'Cancel this registration?': 'Скасувати цю реєстрацію?',
    'The place is freed. A purchase made for this registration is refunded.':
      'Місце звільняється. Оплату за цю реєстрацію буде повернено.',
    'Refund method': 'Спосіб повернення',
    "Credit to the client's deposit": 'Зарахувати на депозит клієнта',
    'Pay out from cash register': 'Видати з каси',
    'Cash register': 'Каса',
    'A place hold is marked attended without naming anyone':
      'Бронь місця можна позначити відвіданою, не вказуючи клієнта',
    'Edit booking': 'Редагувати запис',
    'No free slots for this date': 'Немає вільних слотів на цю дату',
    'Pick a slot': 'Оберіть слот',
    Save: 'Зберегти',
    'Guest name / phone': "Ім'я / телефон гостя",
    'Free start times': 'Вільний час',
  },
};
